/**
 * Picks the translation id for an error handed back by a social sign-in.
 *
 * @param {string} code the `code` of the `st-autherror` cookie
 * @returns {string} translation id
 */
export const idpAuthErrorMessageId = code => {
  switch (code) {
    case 'sso-user-type-mismatch':
      return 'AuthenticationPage.idpUserTypeAlreadyExists';
    case 'idp-account-not-found':
      return 'AuthenticationPage.idpAccountNotFound';
    case 'idp-email-unconfirmed':
      return 'AuthenticationPage.idpEmailUnconfirmed';
    case 'idp-state-mismatch':
      return 'AuthenticationPage.idpStateMismatch';
    default:
      return 'AuthenticationPage.idpAuthFailed';
  }
};
